var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-wrapper finish-step"},[_c('h2',[_vm._v(_vm._s(_vm.stepText.title))]),_c('p',[_vm._v(_vm._s(_vm.stepText.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }